import { JSX } from "react";
/* oxlint-disable-next-line import/no-cycle */
import QdpAttestedEntity from "./QdpAttestedEntity";
import { AttestedEntity } from "./models/attestedEntity";


interface QdpEntityGroupProps {
  entities: AttestedEntity[];
  dataId: string;
  index?: number;
  name: string;
  entityTag: string;
  groupDepth: number;
}

export default function QdpEntityGroup(props: QdpEntityGroupProps): JSX.Element {
  return (
    props.entities &&
    <>
      <li className="list-group-item bordered" data-bs-toggle="collapse" data-bs-target={`#${props.dataId}`}>
        <div className={`col-12 evidence-depth-${props.groupDepth}`}>
          <span className="expandable">{props.name}</span>
        </div>
      </li>
      <div className="collapse" id={`${props.dataId}`}>
        {props.entities.map((x, i) =>
          <QdpAttestedEntity entity={x} key={i} groupDepth={props.groupDepth + 2} entityId={`${props.entityTag}-${x.Xid}${props.index ? `-${props.index}` : ""}`} class={`col-12 evidence-depth-${props.groupDepth + 1}`} sourceId={props.entityTag} />)}
      </div>
    </>
  );
}